import { IS_PROD } from './env';

export const IMAGE_CDN = IS_PROD ? 'https://static-img.linetv.tw' : 'https://static-img-beta.linetv.tw';

/**
 * UTF8 encode to HEX (256 bits)
 * - production: `qjCSEcXuG`
 * - staging: `aAzHSaaQ5`
 */
export const IMAGE_CDN_KEY = IS_PROD
  ? '716a435345635875470000000000000000000000000000000000000000000000'
  : '61417a4853616151350000000000000000000000000000000000000000000000';

/**
 * UTF8 encode to HEX (128 bits)
 * - production: `RRt06Sl74`
 * - staging: `XWr5z2zpH`
 */
export const IMAGE_CDN_IV = IS_PROD ? '5252743036536c373400000000000000' : '585772357a327a704800000000000000';

export const SOURCE_IMAGE_CDN = 'https://img.linetv.tw';
export const SOURCE_IMAGE_BUCKET = 'img.chocotv.com.tw';
